import useNotificationTableColumns from './useNotificationTableColumns'

export default useNotificationTableColumns
